<template>
  <div id="app">
    <navigation></navigation>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">

@import "~bulma/sass/utilities/_all";

// Import master.scss */
@import "~@/assets/scss/master.scss";

// Import all styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
@import "~aos/src/sass/aos.scss";

</style>



// WEBPACK FOOTER //
// src/App.vue